export const keyInitiativesReviewTranslation = {
  title: 'jbp-h2-review-key-initiatives-review-title',
  loadError: 'jbp-h2-review-key-initiatives-review-load-error',
  confirmError: 'jbp-h2-review-key-initiatives-review-confirm-error',
  emptyState: 'jbp-h2-review-key-initiatives-review-empty-state',
  overviewTitle: 'jbp-h2-review-key-initiatives-review-overview-title',
  totalInitiatives: 'jbp-h2-review-key-initiatives-review-total-initiatives',
  goalNdp: 'jbp-h2-review-key-initiatives-review-goal-ndp',
  goalNet: 'jbp-h2-review-key-initiatives-review-goal-net',
  goalTNet: 'jbp-h2-review-key-initiatives-review-goal-tnet',
  strategicInitiative: 'jbp-h2-review-key-initiatives-review-strategic-initiative',
  status: 'jbp-h2-review-key-initiatives-review-status',
  initiatives: 'jbp-h2-review-key-initiatives-review-initiatives',
  openPlanning: 'jbp-h2-review-key-initiatives-review-open-planning',
  confirmReview: 'jbp-h2-review-key-initiatives-review-confirm',
  retry: 'jbp-h2-review-key-initiatives-review-retry',
}
